import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'balise/positionshare/';

class PositionShareService {
    createPositionShareLink(baliseId, durationMinutes) {
        return axios.post(API_URL + baliseId, {
            durationMinutes: durationMinutes
        }, { headers: authHeader() });
    }

    getPositionShareLinks(baliseId) {
        return axios.get(API_URL + baliseId, {
            headers: authHeader()
        });
    }

    revokePositionShareLink(baliseId, shareLinkId) {
        return axios.put(
            API_URL + baliseId + '/' + shareLinkId + '/revoke',
            {},
            { headers: authHeader() }
        );
    }

    extendPositionShareLink(baliseId, shareLinkId, durationMinutes) {
        return axios.put(
            API_URL +
            baliseId +
            '/' +
            shareLinkId +
            '/extend',
            {
                durationMinutes
            },
            {
                headers: authHeader()
            }
        );
    }
}

export default new PositionShareService();